module.exports = __webpack_public_path__ + "static/media/icon_menu.598da3e5.png";